import { Menu, PlusSquare, Share, X } from 'lucide-react';
import React from 'react';

interface InstallHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const InstallHelpModal: React.FC<InstallHelpModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-[#FEFBF6] w-full max-w-md rounded-2xl shadow-xl overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="p-4 border-b border-gray-100 flex justify-between items-center bg-white">
          <h2 className="font-display font-extrabold text-xl text-brand-dark">Install Good Shout</h2>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        
        <div className="p-6 space-y-6">
          <p className="text-brand-dark-light">
            Install Good Shout to your home screen for the best experience. It works just like a native app!
          </p>

          {isIOS ? (
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="p-2 bg-gray-100 rounded-lg">
                  <Share className="w-6 h-6 text-brand-blue" />
                </div>
                <div>
                  <p className="font-medium text-brand-dark">1. Tap the Share button</p>
                  <p className="text-sm text-gray-500">Look for the share icon in your browser toolbar.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="p-2 bg-gray-100 rounded-lg">
                  <PlusSquare className="w-6 h-6 text-brand-dark" />
                </div>
                <div>
                  <p className="font-medium text-brand-dark">2. Select "Add to Home Screen"</p>
                  <p className="text-sm text-gray-500">Scroll down the list to find this option.</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="p-2 bg-gray-100 rounded-lg">
                  <Menu className="w-6 h-6 text-brand-dark" />
                </div>
                <div>
                  <p className="font-medium text-brand-dark">1. Tap the Menu button</p>
                  <p className="text-sm text-gray-500">Usually three dots in the top right corner.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="p-2 bg-gray-100 rounded-lg">
                  <PlusSquare className="w-6 h-6 text-brand-dark" />
                </div>
                <div>
                  <p className="font-medium text-brand-dark">2. Select "Install App"</p>
                  <p className="text-sm text-gray-500">Or "Add to Home Screen" depending on your browser.</p>
                </div>
              </div>
            </div>
          )}
          
          <div className="pt-4">
            <button
              onClick={onClose}
              className="w-full py-3 bg-brand-red text-white font-semibold rounded-xl shadow-lg shadow-brand-red/20 active:scale-95 transition-all"
            >
              Got it!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
